/* Core Web Vitals cleanup: animations disabled to reduce Total Blocking Time. */
document.documentElement.classList.add('epicplacess-cwv-cleanup');
